// extracted by mini-css-extract-plugin
export default {"icon":"sorting-dropdown_icon__XtHfP","active":"sorting-dropdown_active__rT2hk"};